import { GROOVE_CHAT_TEAM_ID_MAPPINGS } from '@/constants/grooveChatTeamIdMappings';

export const state = () => ({
  activeTeamId: null
});

export const mutations = {
  set (state, teamId) {
    state.activeTeamId = teamId;
  }
};

export const actions = {
  setTeamIdFromPath (context, path) {
    const teamId = GROOVE_CHAT_TEAM_ID_MAPPINGS[path];

    context.commit('set', teamId);
  }
};

export const getters = {
  getCurrentId (state) {
    return state.activeTeamId;
  }
};
